import camelcaseKeys from "camelcase-keys";
import snakecaseKeys from "snakecase-keys";

import {
  authorizedDelete,
  authorizedGet,
  authorizedPatch,
  authorizedPost,
} from "@onsite_app/MobileOrderingMenu/authorizedRequests";

import {
  VoucherCartItem,
  VoucherCartItemSchema,
  VoucherCartItemsSchema,
} from "./schema";

export const fetchVoucherCartItems = async (voucherCartUuid: string) => {
  const { body } = await authorizedGet({
    url: `/v1/voucher_carts/${voucherCartUuid}/voucher_cart_items`,
  });
  return VoucherCartItemsSchema.parse(
    camelcaseKeys(body.voucher_cart_items, { deep: true }),
  );
};

const createVoucherCartItem = async ({
  voucherCartUuid,
  ...data
}: Partial<VoucherCartItem> & { voucherCartUuid: string }) => {
  const { body } = await authorizedPost({
    url: `/v1/voucher_carts/${voucherCartUuid}/voucher_cart_items`,
    body: { voucher_cart_item: snakecaseKeys(data, { deep: true }) },
  });
  try {
    return VoucherCartItemSchema.parse(
      camelcaseKeys(body.voucher_cart_item, { deep: true }),
    );
  } catch (error) {
    console.error("Error parsing voucher cart item:", error, body);
    throw error;
  }
};

const updateVoucherCartItem = async ({
  voucherCartUuid,
  ...data
}: Partial<VoucherCartItem> & { voucherCartUuid: string; uuid: string }) => {
  const { body } = await authorizedPatch({
    url: `/v1/voucher_cart_items/${data.uuid}`,
    body: { voucher_cart_item: snakecaseKeys(data, { deep: true }) },
  });
  return VoucherCartItemSchema.parse(
    camelcaseKeys(body.voucher_cart_item, { deep: true }),
  );
};

export const saveVoucherCartItem = async ({
  uuid,
  voucherCartUuid,
  ...data
}: Partial<VoucherCartItem> & { uuid?: string; voucherCartUuid: string }) => {
  if (uuid) {
    return updateVoucherCartItem({ voucherCartUuid, uuid, ...data });
  } else {
    return createVoucherCartItem({ voucherCartUuid, ...data });
  }
};

export const deleteVoucherCartItem = async (uuid: string) => {
  const { body } = await authorizedDelete({
    url: `/v1/voucher_cart_items/${uuid}`,
  });

  return VoucherCartItemSchema.parse(
    camelcaseKeys(body.voucher_cart_item, { deep: true }),
  );
};
